import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal-new";
import SvgIcon from "../SvgIcon";
import { RillContext } from "../../rill/RillReact/share/base";

class ConnectedAccountModal extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { generateLink, onClose, context, t } = this.props;

    const { query } = context.locals;
    const link = query && query.link;
    return (
      <Modal
        width="800px"
        onClose={onClose}
        title={t("connectedAccountModal.title")}
        className="connected-account-modal"
      >
        <div className="body">
          <header className="mb-6">
            <p className="s1">{t("connectedAccountModal.welcomeToPush")}</p>
          </header>
          <div className="welcome connected-account">
            <p className="mb-2">{t("connectedAccountModal.approved")}</p>
            <p className="mb-2">{t("connectedAccountModal.stripeRequired")}</p>
            <p className="mb-2">{t("connectedAccountModal.existingStripe")}</p>
            <b>
              <p className="s1 mb-2">{t("connectedAccountModal.important")}</p>
              <ul className="chip-container">
                <li>
                  <SvgIcon
                    src={"/img/new-icons/chip-warning.svg"}
                    noFilterOnLight={true}
                  />
                  <span>{t("connectedAccountModal.warningOneClick")}</span>
                </li>
                <li>
                  <SvgIcon
                    src={"/img/new-icons/chip-warning.svg"}
                    noFilterOnLight={true}
                  />
                  <span>{t("connectedAccountModal.warningHaveReady")}</span>
                </li>
                <li>
                  <SvgIcon
                    src={"/img/new-icons/chip-warning.svg"}
                    noFilterOnLight={true}
                  />
                  <span>{t("connectedAccountModal.warningFiveMinutes")}</span>
                </li>
              </ul>

              <p className="font-normal">{t("connectedAccountModal.contact")}</p>
            </b>
          </div>
        </div>
        <footer className="items-center">
          {!link && (
            <button data-button-type="primary" onClick={generateLink}>
              {t("connectedAccountModal.generateLink")}
            </button>
          )}
          {link && (
            <div className="link-info">
              <SvgIcon
                src="/img/new-icons/vuesax-linear-info-circle.svg"
                noFilterOnLight={true}
              />
              <span>{query.link}</span>
            </div>
          )}
          {link && (
            <a role="button" data-button-type="primary" href={link}>
              {t("connectedAccountModal.openLink")}
            </a>
          )}
        </footer>
      </Modal>
    );
  }
}

ConnectedAccountModal.contextType = RillContext;

export default withTranslation("coaching-portal")(ConnectedAccountModal);
